import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Info } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import MarkdownRenderer from './MarkdownRenderer';
import Layout from './Layout';

const About: React.FC = () => {
  const navigate = useNavigate();
  const { themeClasses } = useTheme();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/about');
      setContent(response.data.aboutContent || 'About us content will be displayed here.');
    } catch (error) {
      console.error('Error fetching about content:', error);
      toast.error('Failed to load about page');
      setContent('About us content will be displayed here.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout title="About" showBackButton onBack={() => navigate('/')}>
        <div className="p-4">
          <div className={`${themeClasses.card} p-8 text-center rounded-lg`}>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
            <p className={`${themeClasses.textSecondary} mt-4`}>Loading about page...</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="About" showBackButton onBack={() => navigate('/')}>

      {/* Content */}
      <div className="p-4">
        <div className={`${themeClasses.card} rounded-lg`}>
          <div className="flex items-center mb-4">
            <Info className={`w-5 h-5 ${themeClasses.textSecondary} mr-2`} />
            <h2 className={`text-lg font-semibold ${themeClasses.text}`}>About Us</h2>
          </div>
          
          <div className="prose prose-lg max-w-none">
            <MarkdownRenderer content={content} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About;

